import React from "react";
import { useTranslation } from "react-i18next";
import Card from "src/components/Card";
import Grid from "src/components/Grid";
import Layout from "src/components/layout/Layout";
import useAuth from "src/hooks/selectors/useAuth";
import CreateReferralCode from "src/components/referral/share-network/CreateReferralCode";
import ReferralLinkPayouts from "src/components/referral/share-network/ReferralLinkPayouts";
import ReferralTutorial from "src/components/referral/share-network/ReferralTutorial";
import ShareReferralCode from "src/components/referral/share-network/ShareReferralCode";

const DashboardShareNetworkView = () => {
	const { t } = useTranslation("share-network-view", {
		keyPrefix: "index-view",
	});
	const auth = useAuth();

	return (
		<Layout title={t("title")}>
			<Grid columns={1}>
				{!auth.has_referral_code && (
					<>
						<Card>
							<h2 className="mb-12">{t("tutorial.title")}</h2>
							<ReferralTutorial />
							<CreateReferralCode onComplete={console.log} />
						</Card>
					</>
				)}

				{auth.has_referral_code && (
					<>
						<div className="flex my-8 md:flex-row flex-col-reverse md:mx-8 items-center">
							<div className="flex-1">
								<h2 className="text-2xl md:text-4xl text-dark dark:text-white mb-4">
									{t("heading.title")}
								</h2>
								<p>{t("heading.description")}</p>
							</div>
							<div className="flex flex-1 items-center justify-center">
								<img
									className="w-48 md:w-full max-w-[200px]"
									alt="Piggy bank"
									src={"/assets/images/piggy-bank.webp"}
								/>
							</div>
						</div>
						<Card>
							<ShareReferralCode />
						</Card>
						<Card>
							<ReferralTutorial />
						</Card>
						<Card>
							<ReferralLinkPayouts />
						</Card>
					</>
				)}
			</Grid>
		</Layout>
	);
};

export default DashboardShareNetworkView;
